import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { BaseInput, baseInputClasses, Typography } from "@kaltura/ds-react-components";

export const StyledContainer = styled(Box)({
    display: "flex",
    alignItems: "center",
});

export const StyledTypography = styled(Typography)(({ theme }) => ({
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
}));

export const StyledTimeInput = styled(BaseInput)(({ theme }) => ({
    width: 75,
    [`&.${baseInputClasses.readOnly}`]: {
        borderColor: theme.kaltura.palette.tone4,
    },
}));
